import { render, staticRenderFns } from "./HeaderItem.vue?vue&type=template&id=c188a30e&scoped=true&lang=pug&"
import script from "./HeaderItem.vue?vue&type=script&lang=js&"
export * from "./HeaderItem.vue?vue&type=script&lang=js&"
import style0 from "./HeaderItem.vue?vue&type=style&index=0&id=c188a30e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c188a30e",
  null
  
)

export default component.exports